import './App.css';
import MainRouting from "./core/infrastructure/routing/mainRouting";
import {Localizer} from "./infrastructure/localization/localizer";
import "ditmer-embla";
import {StorageKeys} from './infrastructure/storage/storageKeys';
import {InitLeftMenu} from "./core/layout/leftMenu/leftMenuSlice";
import * as Sentry from "@sentry/react";
import config from "./config/config";
import AppInsightsProviderWrapper from 'services/applicationInsights/appInsightsProviderWrapper';
import UserContextProvider from "./core/components/user/userContextProvider";
import { BrowserRouter as Router } from 'react-router-dom';
import { ErrorBoundary } from 'core/infrastructure/errors/errorBoundary';
import NotifikationContextProvider from 'core/components/notifications/context/notifikationContextProvider';
import CookieConsentContextProvider from 'core/components/cookies/context/CookieConsentContextProvider';
import { buildSentryConfig } from 'core/infrastructure/errors/sentry/sentryConfig';
import { PWAContextProvider } from 'core/components/pwa/pwaContextProvider';

const useAppSetup = () => {
    if (!config.SentryDSN && config.environment !== "LokalUdvikling") {
        // Show warning in console on all environments if sentry is not defined:
        console.warn("SentryDSN is not defined");
    }

    Sentry.init(buildSentryConfig(config.SentryDSN, config.environment));

    Localizer.Init();
    InitLeftMenu((sessionStorage.getItem(StorageKeys.leftMenuCollapsed) === 'true') as boolean);
}

function App() {
    useAppSetup();

    return (
        <PWAContextProvider>
            <CookieConsentContextProvider>
                <AppInsightsProviderWrapper>
                    <UserContextProvider>
                        <NotifikationContextProvider>
                            <Router>
                                <ErrorBoundary>
                                    <MainRouting/>
                                </ErrorBoundary>
                            </Router>
                        </NotifikationContextProvider>
                    </UserContextProvider>
                </AppInsightsProviderWrapper>
            </CookieConsentContextProvider>
        </PWAContextProvider>
    );
}



export default App;
